/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ConversationsInputs */

const en_conversations = /** @type {(inputs: ConversationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`conversations`)
};

const es_conversations = /** @type {(inputs: ConversationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`conversaciones`)
};

const fr_conversations = /** @type {(inputs: ConversationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`conversations`)
};

const de_conversations = /** @type {(inputs: ConversationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterhaltungen`)
};

const ja_conversations = /** @type {(inputs: ConversationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`件の会話`)
};

const zh_conversations = /** @type {(inputs: ConversationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`条对话`)
};

const ar_conversations = /** @type {(inputs: ConversationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محادثات`)
};

const id_conversations = /** @type {(inputs: ConversationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`percakapan`)
};

const it_conversations = /** @type {(inputs: ConversationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`conversazioni`)
};

const ru_conversations = /** @type {(inputs: ConversationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`бесед`)
};

const pt_conversations = /** @type {(inputs: ConversationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`conversas`)
};

const ko_conversations = /** @type {(inputs: ConversationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개의 대화`)
};

/**
* | output |
* | --- |
* | "conversations" |
*
* @param {ConversationsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const conversations = /** @type {((inputs?: ConversationsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ConversationsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_conversations(inputs)
	if (locale === "es") return es_conversations(inputs)
	if (locale === "fr") return fr_conversations(inputs)
	if (locale === "de") return de_conversations(inputs)
	if (locale === "ja") return ja_conversations(inputs)
	if (locale === "zh") return zh_conversations(inputs)
	if (locale === "ar") return ar_conversations(inputs)
	if (locale === "id") return id_conversations(inputs)
	if (locale === "it") return it_conversations(inputs)
	if (locale === "ru") return ru_conversations(inputs)
	if (locale === "pt") return pt_conversations(inputs)
	return ko_conversations(inputs)
});